// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle6 from "../../randing/RandingStyle6";

function Randing015({ urlCode, urlCodeSettingId, apiUrl }) {
  return (
    <RandingStyle6
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/015/241118_01.png`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/015/241119_02.gif`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/015/241119_03.jpg`} // 스텝 변경되는 이미지
      questionContainer="1"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/015/241108_05.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori.jpg`}
      // addClass="randing015"
      apiUrl={apiUrl}
    />
  );
}

export default Randing015;
